import React from 'react';
import { CollaborateSettings } from './interfaces';

interface CollaborateDefaultsProps {
    collaborateSettings: CollaborateSettings;
    setCollaborateSettings: (settings: CollaborateSettings) => void;
    showPreview?: boolean;
}

export const CollaborateDefaults = ({
    collaborateSettings,
    setCollaborateSettings,
    showPreview = false,
}: CollaborateDefaultsProps) => (
    <div className="collaborate-defaults">
        <h3>Co-editing defaults for the Egnyte Collaborate</h3>

        <div className="toggle-container">
            <label className="toggle-switch">
                <input
                    type="checkbox"
                    checked={collaborateSettings.makeDefaultCoEditing}
                    onChange={(e) =>
                        setCollaborateSettings({
                            makeDefaultCoEditing: e.target.checked,
                        })
                    }
                />
                <span />
            </label>
            <span className="toggle-label">
                Make Microsoft Office Desktop a default co-editing option in Egnyte Collaborate
            </span>
        </div>

        {showPreview && (
            <div className="document-type-row">
                <div className="icon-container" />
            </div>
        )}
    </div>
);
